export const Language = {
  english: "english",
  russian: "russian",
}

export const LanguageDetails = [
  {abbreviation: "en", name: "English", key: Language.english},
  {abbreviation: "ru", name: "Russian", key: Language.russian},
]



